
import axios from 'axios'
import configs from '@/config/config'
import router from '../router';
import utils from '../utils/index.js';
import Vue from 'vue'
import store from "../store"
import { encrypt } from '../utils/sm4Util'
import { fullDate } from "../utils/tools"


export function request(config) {
  // 1.创建axios的实例
  const instance = axios.create({
    // headers: {
    //   'Content-Type': 'application/json',
    // },
    // baseURL: 'http://192.168.1.55:60000/api',
    // baseURL: process.env.NODE_ENV==='production'? baseUrl:configs.baseUrl,
    baseURL: config.url.indexOf("http") >= 0 ? "" : process.env.NODE_ENV === 'production' ? baseUrl : configs.baseUrl,
    timeout: 60000
  })

  instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

  instance.defaults.headers.Chktoken = encrypt(fullDate())

  // 2.axios的拦截器
  // 2.1.请求拦截的作用
  instance.interceptors.request.use(config => {
    // console.log(config)
    //判断是否登录 
    let isLogin = utils.getCookie("login")
    let lastLoginTime = ''
    if (isLogin) {
      lastLoginTime = utils.getSession("lastLoginTime")
      let nowTime = new Date().getTime()
      // console.log(router.app._route)
      // 判断未操作时间是否超过30分钟
      if (lastLoginTime && nowTime - lastLoginTime > 30 * 60 * 1000) {
        utils.removeSession("lastLoginTime")
        utils.deleteCookie("login")
        store.state.userInfo = {}
        Vue.prototype.$toastN.showToast("因超过30分钟未操作，已退出当前账号登录。")
        window.location.reload()
      }
    }
    utils.setSession("lastLoginTime", new Date().getTime())
    return config
  }, err => {
    // console.log(err);
    Promise.reject(err);
  })

  // 2.2.响应拦截
  instance.interceptors.response.use(res => {
    if (res.status === 200) {
      if (res.data.code === 0) {
        return Promise.resolve(res.data)
      } else {
        if (res.config.url.indexOf("UsersApi") >= 0) {
          return Promise.resolve(res.data)
        }
        if (res.config.url.indexOf("GetById") >= 0) {
          router.replace({
            path: '/notFound',
            query: {
              redirect: router.currentRoute.fullPath
            }
          });
        }
      }
    }
    // return res.data
  }, err => {
    // console.log(err);
    Promise.reject(err);
  })

  if (!config.method || config.method.toUpperCase() == 'GET') {
    const params = config.params || {}
    if (!params._ || !params._t) {
      params._ = Math.floor(Math.random() * 1000000)
    }
  }

  // 3.发送真正的网络请求
  return instance(config)
}

export function requestLink(link) {
  // 1.创建axios的实例
  const instance = axios.create({
    baseURL: link,
    timeout: 5000
  })

  instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  // instance.defaults.headers.post['Content-Type'] = 'application/json';

  instance.defaults.headers.Chktoken = encrypt(fullDate())

  // 2.axios的拦截器
  // 2.1.请求拦截的作用
  instance.interceptors.request.use(link => {
    return link
  }, err => {
    Promise.reject(err);
  })

  // 2.2.响应拦截
  instance.interceptors.response.use(res => {
    return res.data
  }, err => {
    Promise.reject(err);
  })

  // 3.发送真正的网络请求
  return instance(link)
}
